import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { education } from '../../../constants/storageKeys';
import styles from './EduRecommend.module.less';
import Select from '../../../components/Select/Select';
import {
  getEducationRecommendBanner,
  getEducationRecommendGroups,
  getEducationCategoryTags,
  setEducationRecommendLoading,
} from '../../../actions/education';
import CardIndex from '../../../card/CardIndex/CardIndex';
import classNames from 'classnames';
import Btn from '../../../components/Btn/Btn';
import Radio from '../../../components/Radio/Radio';
import Loading from '../../../components/Loading/Loading';
import { useHistory, useLocation } from 'react-router-dom';
import { CONTEXT } from '../../../config';
import { logging, logPostInfo } from '../../../actions/log';
import KeepAlive, { useActivate, useUnactivate } from 'react-activation';
import { logNative, localSetItem, localGetItem } from '../../../utils/utils';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);
// 本页面的学龄阶段与分类页面的学龄阶段是同一个接口
const SelectEducationRecommend = createSelector(
  state => state.education,
  educations => educations.recommend,
);
const SelectEducationMine = createSelector(
  state => state.education,
  educations => educations.category,
);

const eduClassification = {
  6: 'Edu_Reco',
  5: 'Edu_Adult',
  2: 'Edu_Primary',
  3: 'Edu_Junior',
  4: 'Edu_Senior',
};

function EduRecommend({ code }) {
  const [eduStage, setEduStage] = useState({});
  const [tempEduStage, setTempEduStage] = useState({});
  const [options, setOptions] = useState(null);
  const [initTime, setInitTime] = useState(null);
  const [loadings, setLoadings] = useState(false);
  const { banner, groups, loading, error } = useSelector(SelectEducationRecommend);
  const { tags } = useSelector(SelectEducationMine);
  const dispatch = useDispatch();
  // const memoryEduStage = localGetItem(education.EDUSTAGE);
  const memoryEduStage = code;
  const history = useHistory();
  const location = useLocation();
  const { query } = useLocation();
  const logInfoData = useSelector(selectLogInfo);
  const [node, setNode] = useState(null);
  // 浏览时长打桩
  const leaveTimeLog = () => {
    const leaveTime = +new Date();
    dispatch(
      logging({
        category: 'I',
        action: 'View_Time',
        label: '',
        param2: {
          source: eduClassification[code],
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          initTime,
          leaveTime,
          time: leaveTime - initTime,
          age_period: memoryEduStage,
        },
      }),
    );
  };
  useEffect(() => {
    setInitTime(+new Date());
    return () => {
      leaveTimeLog();
    };
  }, []);
  useActivate(() => {
    setInitTime(+new Date());
  });
  useUnactivate(() => {
    leaveTimeLog();
  });
  const pvLog = () => {
    dispatch(
      logging({
        category: 'P',
        action: eduClassification[code],
        label: '',
        param2: {
          source: eduClassification[code],
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          age_period: memoryEduStage,
        },
      }),
    );
    dispatch(
      logPostInfo({
        source: eduClassification[code],
        source_p: logInfoData.source_p,
        source_pp: logInfoData.source_pp,
      }),
    );
  };
  // 打桩 - 记录展现当前页面
  useEffect(() => {
    pvLog();
  }, []);
  useActivate(() => {
    pvLog();
  });
  // 打桩-学段选择弹窗展现
  // useEffect(() => {
  //   if (!memoryEduStage) {
  //     dispatch(
  //       logging({
  //         category: 'P',
  //         action: 'Edu_Choice',
  //         label: '',
  //         param2: {
  //           source: `Edu_Reco`,
  //           source_p: logInfoData.source_p,
  //           source_pp: logInfoData.source_pp,
  //           age_period: memoryEduStage,
  //         },
  //       }),
  //     );
  //   }
  // }, [memoryEduStage]);
  // useEffect(() => {
  //   if (!tags || tags.length === 0) {
  //     dispatch(getEducationCategoryTags());
  //   }
  // }, []);
  // useEffect(() => {
  //   if (tags && tags.length > 0) {
  //     const temp = tags.map(item => ({ ...item, name: item.phaseId, text: item.phaseName }));
  //     setOptions(temp);
  //     const targetStage = temp.find(item => item.phaseId === memoryEduStage);
  //     setEduStage(targetStage || temp[0]);
  //     setTempEduStage(targetStage || temp[0]);
  //   }
  // }, [tags]);
  const getData = () => {
    if (code) {
      dispatch(
        getEducationRecommendBanner({
          phaseId: code,
          pageType: 'education',
        }),
      );
      dispatch(
        getEducationRecommendGroups({
          phaseId: code,
          pageType: 'education',
        }),
      );
    }
  };
  useEffect(() => {
    if (code) {
      getData();
    }
  }, [dispatch, code]);
  const initPage = () => {
    if (node) {
      node.scrollTop = 0;
    }
    setLoadings(true);
    getData();
    const timer = setTimeout(() => {
      setLoadings(false);
      clearTimeout(timer);
    }, 100);
  };
  useEffect(() => {
    // 页面已近选择过学龄阶段
    initPage();
  }, []);
  useActivate(() => {
    if (history.action === 'PUSH') {
      initPage();
    }
  });

  useEffect(() => {
    if (
      banner === null &&
      groups === null &&
      error &&
      location.pathname === `${CONTEXT}/education/recommend`
    ) {
      history.replace(`${CONTEXT}/error`);
    }
  }, [banner, groups]);

  // const handleTempStage = param => () => {
  //   setTempEduStage(param);
  // };
  // const handleStage = (param, source) => {
  //   // setEduStage({ ...param });
  //   localSetItem(education.EDUSTAGE, param.phaseId);

  //   dispatch(
  //     logging({
  //       category: 'C',
  //       action: source === 'btn' ? 'Edu_Choice' : 'Edu_Pulldown_Choice',
  //       label: '',
  //       param2: {
  //         source: `Edu_Reco`,
  //         source_p: logInfoData.source_p,
  //         source_pp: logInfoData.source_pp,
  //         age_period: param.phaseId,
  //       },
  //     }),
  //   );
  // };

  // 展示发生变化打桩
  const changView = content => {
    dispatch(
      logging({
        category: 'I',
        action: `${eduClassification[code]}_Content_Show`,
        label: '',
        param2: {
          source: eduClassification[code],
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          ...content,
          age_period: memoryEduStage,
        },
      }),
    );
  };

  if (!code || loading || loadings) {
    return (
      <div className={styles.loading}>
        <Loading />
      </div>
    );
  }
  return (
    <div className={styles.page} ref={r => setNode(r)} pagescroll="PCStore_Page_Scroll">
      <div className={styles.page_container}>
        {/* <div className={styles.stage}>
          <span className={styles.stageText}>当前学段：</span>
          <Select
            options={options}
            defaultValue={eduStage}
            className={styles.stageSelect}
            handleChange={handleStage}
          />
        </div> */}
        {!loading && (
          <div className={styles.recommend_cards}>
            <div className={styles.banner}>
              {banner &&
                banner.map((item, i) => (
                  <CardIndex
                    data={{ ...item }}
                    key={i}
                    logInfo={{ tag: eduClassification[code], changView }}
                  />
                ))}
            </div>
            {groups &&
              groups.map((item, i) => (
                <CardIndex
                  data={{ ...item }}
                  key={i}
                  logInfo={{ tag: eduClassification[code], changView }}
                />
              ))}
          </div>
        )}
      </div>
      {loading && (
        <div className={styles.loading_content}>
          <Loading />
        </div>
      )}
      {/* {memoryEduStage && (
        <div className={styles.mask}>
          <div className={classNames(styles.popUp)}>
            <div
              className={styles.popUp_close}
              onClick={() => {
                handleStage(tempEduStage, 'btn');
              }}
            >
              <i className="iconfont icon-close" />
            </div>
            <div className={styles.title}>请选择您关心的学习阶段</div>
            <div className={styles.stage}>
              {options &&
                options.map(item => (
                  <React.Fragment key={item.name}>
                    <div
                      className={classNames(
                        styles.stage_item,
                        tempEduStage.name === item.name ? styles.stage_item_active : '',
                      )}
                      onClick={handleTempStage(item)}
                    >
                      {tempEduStage.name === item.name ? (
                        <Radio selected className={styles.stage_icon}>
                          {item.text}
                        </Radio>
                      ) : (
                        <>{item.text}</>
                      )}
                    </div>
                  </React.Fragment>
                ))}
            </div>
            <Btn
              primary
              className={styles.stage_btn}
              handleClick={() => {
                handleStage(tempEduStage, 'btn');
              }}
            >
              选好了
            </Btn>
          </div>
        </div>
      )} */}
    </div>
  );
}

export default props => (
  <KeepAlive name="edurecommend">
    <EduRecommend {...props} />
  </KeepAlive>
);
